export class VaccinationEuvac {
  vaccination_mapping_id?: number;
  patient_id?: number;
  vaccination_date?: string;
  brand_name_id?: number;
  brand_name?: string;
  description?: string;
  vaccination_reason?: string;
  vaccination_status?: string;
  series_number?: number;
  batch_number?: string;
  vaccination_next_date?: string;
  presence_adverse_event?: string;
  reported_adverse_event?: string;
  adverse_event_code?: string;
  observations?: string;
  note?: string;
  status?: number;
  created_date?: string;
  user_id?: number;
  firstname?: string;
  lastname?: string;
  drug_id?: string;
  barcode?: string;
  code?: string;
  code_system?: string;
  code_system_name?: string;
  code_system_version?: string;
  packnr?: string;
  marketing_authorization_holder?: string;
  diseases?: VaccinationEuvacDisease[];
}

export class VaccinationEuvacDisease {
  disease_coding_id?: number;
  code?: string;
  description?: string;
  epSOS_OID?: string;
  version?: string;
}
